let googleMapsLoadPromise = null;

/**
 * Load Google Maps JS API (Places library).
 * Expects REACT_APP_GOOGLE_MAPS_API_KEY to be available at build time.
 *
 * @return {Promise<any>} Resolves with window.google when loaded.
 */
export function loadGoogleMapsPlaces() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google Maps can only load in a browser.'));
  }

  if (window.google?.maps?.places) {
    return Promise.resolve(window.google);
  }

  if (googleMapsLoadPromise) {
    return googleMapsLoadPromise;
  }

  // Prefer a dedicated browser key for Maps JS / Places.
  // Support legacy naming used in this repo.
  const key =
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    process.env.REACT_APP_GEOCODING_KEY ||
    process.env.REACT_APP_GEOCODING_API_KEY;
  if (!key) {
    return Promise.reject(
      new Error(
        'Missing REACT_APP_GOOGLE_MAPS_API_KEY (or REACT_APP_GEOCODING_API_KEY) ' +
        'required for Places Autocomplete.'
      )
    );
  }

  googleMapsLoadPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById('google-maps-js');
    if (existing) {
      // Script tag exists but library may still be loading.
      const check = () => {
        if (window.google?.maps?.places) return resolve(window.google);
        setTimeout(check, 50);
      };
      check();
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-maps-js';
    script.async = true;
    script.defer = true;
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}` +
      `&libraries=places&v=weekly`;
    script.onload = () => {
      if (window.google?.maps?.places) {
        resolve(window.google);
      } else {
        reject(new Error('Google Maps loaded but Places library is unavailable.'));
      }
    };
    script.onerror = () => reject(new Error('Failed to load Google Maps JS.'));
    document.head.appendChild(script);
  });

  return googleMapsLoadPromise;
}


